import React from 'react';

const SuccessBlock = () => {
  return (
    <div className="formWrapper">
      <div className="form-header">
        <h1 style={{ marginBottom: 6 }} className="h1 uppercase center">
          We got it
        </h1>
        <p style={{ marginBottom: 30 }} className="large-p center">
          Thanks for reaching out, we look forward to assisting you.
        </p>
        <p style={{ marginBottom: 54, color: '#F90707' }} className="small-p center">
          Please note: We are experiencing a high volume of inquiries & your wait time may be slightly longer than
          usual. We appreciate your patience while we work to assist you as quickly as possible.
        </p>
      </div>
      <div className="button-wrapper">
        <a href="/" className="main-button">
          GO TO HOMEPAGE
        </a>
        <a href="/collections/new-arrivals" className="main-button">
          SHOP NEW ARRIVALS
        </a>
      </div>
    </div>
  );
};

export default SuccessBlock;
